import axios from 'axios'

const DataManager = {
  getData: function(dataUrls, callback) {
    const requests = dataUrls.map((d) => {
      return DataManager.storedData[d] || axios.get(d);
    });

    axios.all(requests).then(axios.spread((...responses) => {
      const r = [];

      for(let i = 0; i < responses.length; i++){
        if(DataManager.storedData[dataUrls[i]] === undefined){
          DataManager.storedData[dataUrls[i]] = responses[i];
        }

        r.push({...responses[i]});
      }

      callback(r);
    }));
  },

  storedData: {},
  menuList:'https://apps.odenserundt.dk/data/odenseguide/data/data-1.json',
  recommendData: 'https://apps.odenserundt.dk/data/odenseguide/data/data-2.json',
  tagSearchList: 'https://apps.odenserundt.dk/data/odenseguide/data/data-3.json',
  alphabeticListData: 'https://apps.odenserundt.dk/data/odenseguide/data/data-4.json',
  tagList: 'https://apps.odenserundt.dk/data/newtags/all.json',
  searchData: 'https://apps.odenserundt.dk/data/odenseguide/smart.json',
  searchDataExpanded: 'https://apps.odenserundt.dk/data/odenseguide/notsmart.json',
  newTags: 'https://apps.odenserundt.dk/data/newtags/',
  contentOrder: 'https://apps.odenserundt.dk/data/odenseguide/contentOrder.json',
  keyWords: 'https://apps.odenserundt.dk/data/odenseguide/keywords.json'
};

export default DataManager;
